/**
 * A school year's state. The API spells it "Active" (the school's current
 * year), "Planning" or "Past", so it's compared without regard to case.
 */
type WithState = { state: string } | null | undefined;

export function isCurrentYear(year: WithState): boolean {
  return year?.state?.toUpperCase() === 'ACTIVE';
}

export function isPastYear(year: WithState): boolean {
  return year?.state?.toUpperCase() === 'PAST';
}
